// Tableau Reports — in-app replacements for the reports the org used to
// run out of Tableau Server. Each tab replicates the spirit of one
// Tableau workbook (facility heatmap + drilldowns, etc.), not pixel-
// perfect parity. Uses the same tab shell as SpecialReports so the two
// pages feel like siblings.

import React, { useState } from 'react';
import Drilldown20 from './tableauReports/Drilldown20';
import UserLoginsByClient from './tableauReports/UserLoginsByClient';
import SpokeTotals from './tableauReports/SpokeTotals';
import FacilitiesMailing from './tableauReports/FacilitiesMailing';
import './TableauReports.css';

const TABS = [
  {
    id: 'drilldown-2',
    label: 'Drilldown 2.0',
    Component: Drilldown20,
  },
  {
    id: 'user-logins-by-client',
    label: 'Total Logins by Client Type',
    Component: UserLoginsByClient,
  },
  {
    id: 'spoke-totals',
    label: 'Spoke Totals',
    Component: SpokeTotals,
  },
  {
    id: 'facilities-mailing',
    label: 'Facilities with Mailing Address',
    Component: FacilitiesMailing,
  },
];

function TableauReports() {
  const [activeTab, setActiveTab] = useState(TABS[0].id);
  const ActiveComponent = (TABS.find(t => t.id === activeTab) || TABS[0]).Component;

  return (
    <>
      <div className="tableau-page-header">
        <div>
          <h1>Tableau Reports</h1>
          <div className="tableau-page-sub">
            In-app replacements for the reports we used to run out of Tableau.
            Each tab captures the spirit of one workbook — not pixel-perfect parity.
            Scope a customer, saved filter, or facility set from My Customers / My Filters
            to limit which facilities appear.
          </div>
        </div>
      </div>

      <div className="tableau-tabs" role="tablist">
        {TABS.map(t => (
          <button
            key={t.id}
            role="tab"
            aria-selected={activeTab === t.id}
            className={`tableau-tab ${activeTab === t.id ? 'active' : ''}`}
            onClick={() => setActiveTab(t.id)}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="tableau-tab-body" role="tabpanel">
        <ActiveComponent />
      </div>
    </>
  );
}

export default TableauReports;
